export default "__VITE_ASSET__4d560d43__"